import Axios from "axios";
import {
    SET_HRM_DESIGNATION_LIST,
    UNSET_HRM_DESIGNATION_LIST,
  } from "@/store/mutation-types";
import { saveUpdateHrmDesignation, getHrmDesignationList } from "@/store/api";
// initial state
const state = {
  getHrmDesignationList: [],
};

const getters = {
  getHrmDesignationList(state) {
    return state.getHrmDesignationList;
  },
};

const mutations = {
  [SET_HRM_DESIGNATION_LIST](state, data) {
    state.getHrmDesignationList = data;
  },
  [UNSET_HRM_DESIGNATION_LIST](state) {
    state.getHrmDesignationList = [];
  },

};

const actions = {

  saveUpdateHrmDesignation({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateHrmDesignation, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getHrmDesignationList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmDesignationList, data)
        .then(function (response) {
          commit('SET_HRM_DESIGNATION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_DESIGNATION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
